import BackToTop from './BackToTop'
// Uncomment the below to migrate to stateful component
// import BackToTopContainer from './BackToTopContainer'

export { BackToTop }
export default BackToTop
// Uncomment the below to migrate to stateful component
// export { BackToTopContainer }
// export default { BackToTopContainer }
